import { LoadableAfterPaint } from '@confluence/loadable';

export const Nav3SpaceNavigationContent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-Nav3SpaceNavigationContent" */ './Nav3SpaceNavigationContent'
			)
		).Nav3SpaceNavigationContent,
});

export const SpaceNavigationContent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceNavigationContent" */ './SpaceNavigationContent'
			)
		).SpaceNavigationContent,
});
